/* Página responsável por ativar o cadastro do usuário. Ela é acessada através de um link enviado por e-mail após o usuário se cadastrar. O link contém o usuário que é usado para verificar a autenticidade da solicitação de ativação. O link com o usuário fará uma chamada à API para ativar o cadastro.

*/

import { useEffect, useState } from "react";
import { useSearchParams ,useNavigate, useLocation } from "react-router-dom";

const  AtivarCadastro = () => {

    const [searchParams] = useSearchParams();
    const [mensagem, setMensagem] = useState("Aguarde, ativando seu cadastro...");
    const [status, setStatus] = useState("aguardando");
    const navigate = useNavigate(); // Hook para navegação programática 

    useEffect(() => {
        const controller = new AbortController(); //Utilizado para cancelar a requisição caso o componente seja desmontado antes da conclusão da requisição. Isso ajuda a evitar erros de memória e chamadas desnecessárias à API.
        

        console.log('useEffect disparou'); // Se aparecer 2x no console → é StrictMode

        const ativarCadastro = async () => {
            const usuario = searchParams.get("u"); // Pega o ?u= da URL

            if (!usuario) {

                setMensagem("Link inválido. Parâmetro de usuário não encontrado.");
                setStatus("erro");
                
                navigate('/resultado', { 
                          state: { 
                            status: status,
                            mensagem: mensagem
                          }
                        });

                
                return;
            }

            const url = `${process.env.REACT_APP_API_URL}/user-ativar?u=${encodeURIComponent(usuario)}`;

            try {
                const resposta = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    signal: controller.signal // ← Sem isso o abort não funciona
                });
                

                if (!resposta.ok) {
                    throw new Error(`Erro na requisição: ${resposta.status}`);
                }

                const dadosRetorno = await resposta.json();

                if (dadosRetorno.status === 'sucesso') {
                    setStatus('sucesso');
                    setMensagem(dadosRetorno.mensagem || 'Cadastro ativado com sucesso!');
                    navigate('/resultado', { 
                          state: { 
                            status: dadosRetorno.status,
                            mensagem: dadosRetorno.mensagem
                          }
                        });

                } else {
                    setStatus('erro');
                    setMensagem(dadosRetorno.mensagem || 'Falha ao ativar cadastro.');
                    navigate('/resultado', { 
                          state: { 
                            status: dadosRetorno.status,
                            mensagem: dadosRetorno.mensagem
                          }
                        });
                }
            } catch (error) {
                if (error.name === 'AbortError') return; // ← Ignora silenciosamente o cancelamento
                setStatus('erro');
                setMensagem('Ocorreu um erro ao ativar o cadastro: ' + error.message);
                navigate('/resultado', { 
                      state: { 
                        status: 'erro',
                        mensagem: 'Ocorreu um erro ao ativar o cadastro: ' + error.message
                      }
                    });
            }
        };

        ativarCadastro();

        return () => controller.abort(); // ✅ Cancela a requisição quando desmonta
    }, []);



return (
    <div>
        <h1>Ativação de Cadastro</h1>
        <p>Status: {status}</p>
        <p>{mensagem}</p>
    </div>
);


}
export default AtivarCadastro;